"use client";

import { createContext, useContext, ReactNode } from "react";

type FeesContextType = {
  fees: any;
};

const FeesContext = createContext<FeesContextType | undefined>(undefined);

export function FeesProvider({
  children,
  fees,
}: {
  children: ReactNode;
  fees: any;
}) {
  return (
    <FeesContext.Provider value={{ fees }}>
      {children}
    </FeesContext.Provider>
  );
}

export function useFees() {
  const context = useContext(FeesContext);
  if (context === undefined) {
    throw new Error("useFees must be used within a FeesProvider");
  }
  return context.fees;
}
